// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/selectedasay.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/selectedaask.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch-field {
      overflow: hidden;
      width: 100%;
text-align: center;
  }
  
  /* .switch-title {
      font-weight: bold;
    margin-bottom: 6px;
  } */
  
  .switch-field input {
      position: absolute !important;
      clip: rect(0, 0, 0, 0);
      height: 1px;
      width: 1px;
      border: 0;
      overflow: hidden;
  }
  
  .switch-field label {
    display: inline-block;
    width: 110px;
    border-radius: 25px;
    background-color: #fff;
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    text-shadow: none;
    padding: 6px 26px;
    transition: all 0.1s ease-in-out;
    margin-bottom: 0px;
    position:absolute;
    top: 0;
    line-height: 1.8;
    text-align: center;
    height: 34px;
  }
  .switch-field label:first-child {
    left: 0;
  }
  .switch-field label:last-child {
    right: 0;
  }

  .switch-field label:hover {
      cursor: pointer;
  }
  .rightlabel{
      border-radius: 0px 25px 25px 0px;
  }
  .leftlabel{
    left: 0;
}

  .switch-field #switch_right:checked + label {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 22px center #36B549;
    color: #fff;
    box-shadow: none;
    border-radius: 50px;
    right: -1px;
    top: -1px;
    
    z-index: 2;
    height: 36px;
    padding-left: 50px;
  }
  #switch_right:checked label{
      border: none;
  }
  .switch-field #switch_left:checked + label {
    /* background-color: #1955a5; */
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 18px #2168B2 ;
    color: #fff;
    box-shadow: none;
    
    left: -1px;
    top: -1px;
    height: 36px;
    z-index: 2;
    padding-left: 50px;
  }
  .togglediv{
    display: inline-block;
    border: 1px solid #000;
    border-radius: 25px;
    background: #fff;
    margin-bottom: 12px;
    width: 190px;
    height: 36px;
    position: relative;
  }
  .togglediv::after {
    content: " ";
    width: 1px;
    height: 35px;
    position: absolute;
    background: #000;
    left: 50%;
    top:0;
  }
`, "",{"version":3,"sources":["webpack://./src/Assets/css/ReusuableComponents/ToggleSwitch.css"],"names":[],"mappings":"AAAA;MACM,gBAAgB;MAChB,WAAW;AACjB,kBAAkB;EAChB;;EAEA;;;KAGG;;EAEH;MACI,6BAA6B;MAC7B,sBAAsB;MACtB,WAAW;MACX,UAAU;MACV,SAAS;MACT,gBAAgB;EACpB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;IACjB,MAAM;IACN,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,OAAO;EACT;EACA;IACE,QAAQ;EACV;;EAEA;MACI,eAAe;EACnB;EACA;MACI,gCAAgC;EACpC;EACA;IACE,OAAO;AACX;;EAEE;IACE,iFAA4E;IAC5E,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,SAAS;;IAET,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;EACA;MACI,YAAY;EAChB;EACA;IACE,+BAA+B;IAC/B,2EAAsE;IACtE,WAAW;IACX,gBAAgB;;IAEhB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,KAAK;EACP","sourcesContent":[".switch-field {\r\n      overflow: hidden;\r\n      width: 100%;\r\ntext-align: center;\r\n  }\r\n  \r\n  /* .switch-title {\r\n      font-weight: bold;\r\n    margin-bottom: 6px;\r\n  } */\r\n  \r\n  .switch-field input {\r\n      position: absolute !important;\r\n      clip: rect(0, 0, 0, 0);\r\n      height: 1px;\r\n      width: 1px;\r\n      border: 0;\r\n      overflow: hidden;\r\n  }\r\n  \r\n  .switch-field label {\r\n    display: inline-block;\r\n    width: 110px;\r\n    border-radius: 25px;\r\n    background-color: #fff;\r\n    color: rgba(0, 0, 0, 0.6);\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    text-align: left;\r\n    text-shadow: none;\r\n    padding: 6px 26px;\r\n    transition: all 0.1s ease-in-out;\r\n    margin-bottom: 0px;\r\n    position:absolute;\r\n    top: 0;\r\n    line-height: 1.8;\r\n    text-align: center;\r\n    height: 34px;\r\n  }\r\n  .switch-field label:first-child {\r\n    left: 0;\r\n  }\r\n  .switch-field label:last-child {\r\n    right: 0;\r\n  }\r\n\r\n  .switch-field label:hover {\r\n      cursor: pointer;\r\n  }\r\n  .rightlabel{\r\n      border-radius: 0px 25px 25px 0px;\r\n  }\r\n  .leftlabel{\r\n    left: 0;\r\n}\r\n\r\n  .switch-field #switch_right:checked + label {\r\n    background: url(../../images/selectedasay.svg) no-repeat 22px center #36B549;\r\n    color: #fff;\r\n    box-shadow: none;\r\n    border-radius: 50px;\r\n    right: -1px;\r\n    top: -1px;\r\n    \r\n    z-index: 2;\r\n    height: 36px;\r\n    padding-left: 50px;\r\n  }\r\n  #switch_right:checked label{\r\n      border: none;\r\n  }\r\n  .switch-field #switch_left:checked + label {\r\n    /* background-color: #1955a5; */\r\n    background: url(../../images/selectedaask.svg) no-repeat 18px #2168B2 ;\r\n    color: #fff;\r\n    box-shadow: none;\r\n    \r\n    left: -1px;\r\n    top: -1px;\r\n    height: 36px;\r\n    z-index: 2;\r\n    padding-left: 50px;\r\n  }\r\n  .togglediv{\r\n    display: inline-block;\r\n    border: 1px solid #000;\r\n    border-radius: 25px;\r\n    background: #fff;\r\n    margin-bottom: 12px;\r\n    width: 190px;\r\n    height: 36px;\r\n    position: relative;\r\n  }\r\n  .togglediv::after {\r\n    content: \" \";\r\n    width: 1px;\r\n    height: 35px;\r\n    position: absolute;\r\n    background: #000;\r\n    left: 50%;\r\n    top:0;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
